export default angular.module('HelpScoutBeacon', []);
